import { bindActionCreators } from 'redux';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Dimmer, Loader } from 'semantic-ui-react';
import { setUserId, setUserProperties } from 'util/amplitude';
import userActions from '../../redux/user/actions';
import authActions from '../../redux/auth/actions';
import { updateDocumentTitle } from '../../util/utils';
import './App.scss';
import { registerSessionTimeoutCallback } from '../../util/sessionTimeout';
import SystemDown from '../../components/SystemDown/SystemDown';

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      pageTitle: null,
    };
  }

  componentDidMount() {
    registerSessionTimeoutCallback(() => {
      this.props.actions.expireSessionRequest();
    });
    this.props.actions.currentUserRequest();
  }

  componentDidUpdate(prevProps) {
    if (
      this.props?.location?.pathname !== prevProps?.location?.pathname ||
      !this.state.pageTitle
    ) {
      const title = updateDocumentTitle(this.props.location.pathname);
      document.title = title;
      this.setState({ pageTitle: title });
    }
    if (!this.props.currentUser) {
      return;
    }
    if (this.props.currentUser !== prevProps.currentUser) {
      setUserId(this.props.currentUser.id);

      const userProperties = {
        userId: this.props.currentUser.id,
        userType: this.props.currentUser.type,
        userPermission: this.props.currentUser.roles,
        userRole: this.props.currentUser.personaId || '',
        dealerId: this.props.currentUser.dealer_id || 'Upstart',
      };
      setUserProperties(userProperties);
    }
  }

  render() {
    if (
      !this.props.isByPassMaintenanceMode &&
      this.props.systemStatus.isSystemDown
    ) {
      return <SystemDown restoreDate={this.props.systemStatus.restoreDate} />;
    }

    if (this.props.fetching) {
      return (
        <Dimmer active inverted>
          <Loader inverted content="Loading" />
        </Dimmer>
      );
    }
    return <div />;
  }
}

App.propTypes = {
  fetching: PropTypes.bool,
  actions: PropTypes.object.isRequired,
  location: PropTypes.object,
  currentUser: PropTypes.object,
};

const mapStateToProps = ({ user, global }) => ({
  fetching: user.fetching,
  systemStatus: global.systemStatus,
  isByPassMaintenanceMode: global.isByPassMaintenanceMode,
  currentUser: user.currentUser,
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({ ...userActions, ...authActions }, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(App);
